<template>
  <div class="news_box">
    <div class="news_box_left">
      <div class="news_box_left1">
        <h2 class="ellipsis-aRow">{{ newsdata.title }}</h2>
        <div class="news_box_left1l">
          <img src="@/assets/icon/read_ico_sj.png" />
          <span>发布时间：{{ newsdata.createTime | filterDate }}</span>
        </div>
      </div>
      <div class="news_box_left2" v-html="formatImg(newsdata.content)"></div>
    </div>
  </div>
</template>

<script>
import { selectNewsById, getGuessFavouriteNoLogin } from "@/api/index/index.js";
export default {
  data() {
    return {
      newsdata: {},
      GuessFavourite: [],
    };
  },
  created() {
    this.selectNewsById();
    this.getGuessFavouriteNoLogin();
  },
  methods: {
    selectNewsById() {
      selectNewsById({
        id: this.$route.query.newsId,
      }).then((res) => {
        // console.log(res)
        this.newsdata = res.data;
      });
    },
    getGuessFavouriteNoLogin() {
      getGuessFavouriteNoLogin({}).then((res) => {
        //取前5个作为推荐商品展示的内容
        this.GuessFavourite = res.data.slice(0, 5);
      });
    },
    tobookDetail(id) {
      let routeUrl = this.$router.resolve({
        path: "/bookstore/bookstoreDetail",
        query: { goodsId: id },
      });
      window.open(routeUrl.href, "_blank");
    },
    share() {
      this.$alert("此功能正在开发中，敬请期待", "提示信息");
    },

    formatImg(str) {
      if (str) {
        return str.replace(/\<img/g, "<img style='max-width:100%;'");
      }
    },
  },
};
</script>

<style scoped>
.news_box {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.news_box_left {
  width: 100%;
  float: left;
  min-height: 100px;
  padding: 12px 10px;
  box-sizing: border-box;
  background: #fffefd;
}

.news_box_right {
  float: right;
  width: 304px;
  padding: 8px 8px;
  box-sizing: border-box;
  background: #fffefd;
}

.share-img {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  display: flex;
  align-items: center;
  float: right;
  margin-top: -3px;
}

.share-img img {
  width: 18px;
  height: 18px;
  margin-left: 8px;
  cursor: pointer;
}

.news_box_left1 {
  width: 100%;
  float: left;
  border-bottom: 1px solid #eaddd4;
}

.news_box_left1 h2 {
  font-size: 18px;
  width: 100%;
  float: left;
  margin-bottom: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}

.news_box_left1l {
  float: left;
  margin-bottom: 8px;
}

.news_box_left1l img {
  float: left;
  margin-right: 9px;
  width: 13px;
}

.news_box_left1l span {
  float: left;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}

.news_box_left2 {
  width: 100%;
  float: left;
  margin-top: 14px;
}
.news_box_left2 img {
  width: 100%;
}

.news_box_right1 {
  width: 100%;
  float: left;
  margin-top: 9px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f2f2;
}

.news_box_right1_img {
  width: 143px;
  cursor: pointer;
  height: 143px;
  background: #ffffff;
  border: 1px solid #f2f2f2;
  margin: 0 auto;
  margin-bottom: 10px;
}

.news_box_right1b {
  display: table;
  margin: 0 auto;
}

.news_box_right1b img {
  float: left;
  width: 27px;
  height: 20px;
  margin-right: 4px;
}

.news_box_right1b p {
  float: left;
  font-size: 14px;
  max-width: 220px;
  cursor: pointer;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
}

.news_box_right2 {
  width: 100%;
  float: left;
}

.news_box_right2 li {
  width: 250px;
  float: left;
  /* line-height: 45px; */
  padding: 15px 0;
  border-bottom: 1px solid #f2f2f2;
  padding-left: 18px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
  box-sizing: border-box;
  list-style: none;
  cursor: pointer;
  position: relative;
}
.news_box_right2 li > span {
  width: 245px;
  display: inline-block;
  max-height: 45px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #333333;
}
.news_box_right2 li:before {
  content: "";
  position: absolute;
  left: 5px;
  top: 20px;
  width: 5px;
  height: 5px;
  background: #0084d2;
  border-radius: 50%;
}
</style>
